import { render, staticRenderFns } from "./Reparaciones.vue?vue&type=template&id=575f2385&"
import script from "./Reparaciones.vue?vue&type=script&lang=js&"
export * from "./Reparaciones.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports